import useChatAndUserData from "../hooks/useChatAndUserData";
import MKBox from "components/MKBox";
import CircularProgress from "@mui/material/CircularProgress";
import MKTypography from "components/MKTypography";
import { useNavigate } from "react-router-dom";

function ChatDetails() {
  const { chatData, loading } = useChatAndUserData();
  const navigate = useNavigate();

  if (loading) {
    return (
      <MKBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </MKBox>
    );
  }

  return (
    <MKBox py={2}>
      <MKTypography variant="body2">
        <strong>Onderwerp:</strong> {chatData.subject}
      </MKTypography>
      <MKTypography
        variant="body2"
        onClick={() => {
          navigate(`/admin/user-database/${chatData.userId}`);
        }}
        sx={{
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
            color: "primary.main",
          },
        }}
      >
        {chatData.userName ? (
          <>
            <strong>Gebruiker:</strong> {chatData.userName} ({chatData.userEmail})
          </>
        ) : (
          <>
            <strong>Gebruiker:</strong> {chatData.userEmail}
          </>
        )}
      </MKTypography>
      <MKTypography variant="body2">
        <strong>Datum:</strong>{" "}
        {new Date(chatData.createdAt).toLocaleDateString("nl-NL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
      </MKTypography>
    </MKBox>
  );
}

export default ChatDetails;
